import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

/** A pdf.js zoom: a factor (1 = 100 %) or one of its presets */
export type TPdfScale = number | "page-width" | "page-fit" | "auto";

const loadModules = async () => {
  const pdfjsLib = await import("pdfjs-dist");
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
  // pdfjs-dist ships its viewer components reading the library from this global: set before they load
  (globalThis as typeof globalThis & { pdfjsLib?: typeof pdfjsLib }).pdfjsLib = pdfjsLib;
  const viewer = await import("pdfjs-dist/web/pdf_viewer.mjs");
  return { pdfjsLib, viewer };
};

let modules: ReturnType<typeof loadModules> | null = null;

// pdf.js loads with the first PDF shown, not with the pages that can show one
export const loadPdfjs = () => {
  // A failed chunk load is tried again by the next viewer
  modules ??= loadModules().catch((error) => {
    modules = null;
    throw error;
  });
  return modules;
};
